if (!customElements.get('dog-review-slider')) {
  customElements.define(
    'dog-review-slider',
    class DogReviewSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        this.prev = this.querySelector('[data-review-prev]');
        this.next = this.querySelector('[data-review-next]');
        if (!this.track || this.track.children.length < 2) return;

        this.step = () => {
          const card = this.track.querySelector('.dog-tp__card');
          const styles = card ? window.getComputedStyle(this.track) : null;
          const gap = styles ? parseFloat(styles.columnGap || styles.gap) || 16 : 16;
          return (card?.getBoundingClientRect().width || 320) + gap;
        };

        this.scrollByCard = (direction) => {
          this.track.scrollBy({ left: this.step() * direction, behavior: 'smooth' });
        };

        this.prev?.addEventListener('click', () => this.scrollByCard(-1));
        this.next?.addEventListener('click', () => this.scrollByCard(1));

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.start();
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
      }

      start() {
        this.stop();
        this.timer = window.setInterval(() => {
          const max = this.track.scrollWidth - this.track.clientWidth - 4;
          if (this.track.scrollLeft >= max) {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            this.scrollByCard(1);
          }
        }, 5000);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
      }

      disconnectedCallback() {
        this.stop();
      }
    }
  );
}

if (!customElements.get('dog-cart-reviews')) {
  customElements.define(
    'dog-cart-reviews',
    class DogCartReviews extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        if (!this.track || this.track.children.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.index = 0;
        this.timer = window.setInterval(() => {
          this.index = (this.index + 1) % this.track.children.length;
          const slide = this.track.children[this.index];
          this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }, 4500);
      }

      disconnectedCallback() {
        if (this.timer) window.clearInterval(this.timer);
      }
    }
  );
}

(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.dataLayer = window.dataLayer || [];

  document.addEventListener('click', (event) => {
    if (event.target.closest('#CartDrawer-Checkout, [name="checkout"]')) {
      window.dataLayer.push({ event: 'begin_checkout' });
    }
  });

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'product-form') window.dataLayer.push({ event: 'add_to_cart' });
      if (event.source === 'cart-items') window.dataLayer.push({ event: 'view_cart' });
    });
  }

  const dialog = document.querySelector('[data-dog-exit]');
  const KEY = 'dog-exit-shown';
  if (!dialog || sessionStorage.getItem(KEY) || reduced) return;

  const show = () => {
    if (sessionStorage.getItem(KEY)) return;
    sessionStorage.setItem(KEY, '1');
    if (typeof dialog.showModal === 'function') dialog.showModal();
  };

  dialog.querySelector('[data-exit-close]')?.addEventListener('click', () => dialog.close());

  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  if (isMobile) {
    let lastY = window.scrollY;
    window.addEventListener(
      'scroll',
      () => {
        if (window.scrollY < lastY - 80 && window.scrollY > 400) show();
        lastY = window.scrollY;
      },
      { passive: true }
    );
  } else {
    document.addEventListener('mouseout', (event) => {
      if (event.clientY <= 0) show();
    });
  }

  window.setTimeout(show, 30000);
})();
